const options = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '47a386c162mshac39b2c0af4190fp166603jsn0bce515f4b20',
		'X-RapidAPI-Host': 'shazam.p.rapidapi.com',
	},
};

export default options;
